import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const Background = styled("div")({
  backgroundColor: "#cedbd7",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  height: "100%",
  position: "relative",
});

const BackGround = styled("div")({
  backgroundColor: "#1b0a3c",
  backgroundSize: "cover",
  color: "white",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  height: "100%",
  position: "relative",
});

const MarqueeContainer = styled(Box)({
  overflow: "hidden",
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  width: "100%",
  backgroundColor: "green",
  position: "relative",
});

const MarqueeText = styled(Typography)({
  display: "inline-block",
  color: "white",
  animation: "marquee 15s linear infinite",
  "@keyframes marquee": {
    "0%": { transform: "translateX(100%)" },
    "100%": { transform: "translateX(-100%)" },
  },
});

const Technology = () => {
  return (
    <>
      <Background>
        <MarqueeContainer>
          <MarqueeText variant="h6">
            Our patented liquid adulteration detection technology is now
            available for licensing.
          </MarqueeText>
        </MarqueeContainer>
        <Box
          id="firstSection"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            padding: 0,
          }}
        >
          <Box
            sx={{
              flex: 1,
              borderRight: "1px solid black",
              paddingLeft: { xs: 3, md: 5 },
              paddingRight: { xs: 3, md: 5 },
              paddingTop: 3,
              paddingBottom: 2,
            }}
          >
            <Typography
              sx={{ fontSize: { xs: "20px", md: "30px" } }}
              variant="h4"
              gutterBottom
            >
              Reimagining Wound Care: Smart. Painless. Predictive
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "18px", md: "25px" },
                marginBottom: "10px",
              }}
              variant="body1"
            >
              A new era in healing begins—with AI-enabled, infection-resistant
              dressings that think, adapt, and protect.
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "15px", md: "20px" },
                marginBottom: "10px",
              }}
              variant="body1"
            >
              Chronic wounds are silent epidemics. From diabetic ulcers to
              post-surgical complications, they're difficult to monitor, slow to
              heal, and prone to dangerous infections. Today’s dressings do
              little more than cover the problem—they can’t see it, predict it,
              or stop it.
            </Typography>

            <Box display="flex" justifyContent="center" marginBottom="15px">
              <Box
                component="img"
                src="https://res.cloudinary.com/digfyljcv/image/upload/v1744084520/nqpjgg2g1vclyltnkfjn.png"
                alt="SWD_HD"
                sx={{
                  maxHeight: { xs: "120px", sm: "150px", md: "250px" },
                  objectFit: "contain",
                  marginBottom: "10px",
                  borderRadius: "5%",
                  marginLeft: "-10px",
                  marginTop: "10px",
                }}
              />
            </Box>

            <Typography
              sx={{ fontSize: { xs: "18px", md: "25px" } }}
              variant="h4"
              gutterBottom
            >
              Our Breakthrough
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
            >
              We’ve developed a radically new class of wound dressings—inspired
              by nature, built with nanoengineering, and powered by artificial
              intelligence. Here’s how we’re changing the game:
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              <strong>Infection-Resistant by Design:</strong> Surfaces inspired
              by the lotus leaf repel fluids and block microbial adhesion,
              reducing infection risk and biofilm formation.
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              <strong>Real-Time Intelligence, Built-In:</strong> Embedded
              biosensors track wound pH, temperature, and inflammation. AI
              analytics interpret the data, flag issues early, and guide
              clinicians toward faster, smarter decisions.
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              <strong>Pain-Free, Self-Cleaning Interface:</strong> The dressing
              never sticks to the skin, and rarely needs to be changed. It
              cleans itself, protects delicate tissue, and eliminates
              unnecessary trauma.
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              <strong>Adapts to You:</strong> Smart adhesion tech ensures the
              dressing stays on when it should—and comes off painlessly when it
              must.
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              <strong>Healing Insights, Anywhere:</strong> A connected dashboard
              gives doctors, nurses, and caregivers instant access to wound
              status, enabling proactive treatment and better outcomes.
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <Box
                component="img"
                src="https://res.cloudinary.com/digfyljcv/image/upload/v1744084431/c5tbugpsbni6nctg8rv7.png"
                alt="SWD_CYCLE"
                sx={{
                  maxHeight: { xs: "200px", md: "250px" },
                  objectFit: "contain",
                  marginBottom: "10px",
                  borderRadius: "5%",
                  marginLeft: "-10px",
                  marginTop: "10px",
                }}
              />
              <Box
                component="img"
                src="https://res.cloudinary.com/digfyljcv/image/upload/v1744084322/oszcm5vzyadgp3playot.jpg"
                alt="SWD"
                sx={{
                  maxHeight: { xs: "150px", md: "250px" },
                  objectFit: "contain",
                  marginBottom: "10px",
                  borderRadius: "5%",
                  marginLeft: "-10px",
                  marginTop: "10px",
                }}
              />
            </Box>

            <Typography
              sx={{ fontSize: { xs: "20px", md: "30px" } }}
              variant="h4"
              gutterBottom
            >
              Who It’s For
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              Patients with{" "}
              <strong>diabetic foot ulcers, pressure injuries, or burns</strong>
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              Hospitals needing{" "}
              <strong>post-surgical wound surveillance</strong>
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              Elder care centers managing{" "}
              <strong>long-term chronic wounds</strong>
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              Home caregivers who need reliable, actionable insight between
              visits
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              Billions are spent annually on wound care, yet outcomes remain
              stagnant. This platform offers a leap forward: faster healing,
              fewer infections, lower costs, and better patient lives—without
              adding complexity.
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "15px", md: "20px" } }}
              variant="body1"
              paragraph
            >
              With a wound care market approaching $28B by 2028, our technology
              sits at the intersection of AI, biosensing, and regenerative
              healthcare—creating massive potential for health systems,
              insurers, and device partners alike.
            </Typography>
          </Box>
        </Box>
      </Background>
      <BackGround>
        <Box
          id="secondSection"
          sx={{
            paddingTop: 3,
            paddingLeft: { xs: 3, md: 5 },
            paddingRight: { xs: 3, md: 5 },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box
            sx={{
              flex: 1,
              order: { xs: 1, md: 1 },
            }}
          >
            <Typography
              sx={{ fontSize: { xs: "20px", md: "30px" } }}
              variant="h4"
              gutterBottom
            >
              Welcome to the Future of Liquid Purity
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "15px", md: "20px" },
                marginBottom: "10px",
              }}
              variant="body1"
            >
              Ever wondered if the milk you're drinking is as pure as it should
              be? At Natulatech Solutions, we’ve developed Lotuster, an
              omni-liquid adulterant detection device that’s revolutionizing the
              way we ensure the quality and purity of our liquids. Portable,
              affordable, and incredibly precise, Lotuster is here to transform
              quality control across industries, especially for dairy farmers.
            </Typography>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src="https://res.cloudinary.com/digfyljcv/image/upload/v1718031693/website%20pics/Lotuster_design_gfxfao.png"
                alt="lotuster-pic"
                sx={{
                  maxHeight: { xs: "150px", md: "250px" },
                  objectFit: "contain",
                  marginBottom: "10px",
                  borderRadius: "5%",
                  marginLeft: "-10px",
                }}
              />
            </Box>
            <Typography
              sx={{
                fontSize: { xs: "15px", md: "20px" },
                marginBottom: "10px",
              }}
              variant="body1"
            >
              Patent (IP India): Device, Method, and Substance for Detection of
              Adulteration in Liquids.
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              padding: 3,
              order: { xs: 2, md: 1 },
            }}
          >
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src="https://res.cloudinary.com/digfyljcv/image/upload/v1744087870/Patent_Certificate-1_vfshvp.jpg"
                alt="Patent Certificate"
                sx={{
                  maxHeight: { xs: "350px", sm: "450px", md: "600px" },
                  objectFit: "contain",
                  borderRadius: "5%",
                  marginLeft: "-50px",
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box id="thirdSection" sx={{ padding: { xs: 3, md: 5 } }}>
          <Typography
            sx={{ fontSize: { xs: "20px", md: "30px" } }}
            variant="h4"
            gutterBottom
          >
            What is Lotuster®?
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "15px", md: "20px" } }}
            variant="body1"
          >
            Lotuster is a cutting-edge device inspired by the pristine
            properties of the lotus leaf. Just as the lotus leaf repels
            impurities, Lotuster detects them with unmatched accuracy. Whether
            you're a dairy farmer, a food and beverage producer, or a
            health-conscious consumer, Lotuster empowers you to verify liquid
            purity instantly and effortlessly.
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "18px", md: "25px" } }}
            mt={2}
            variant="h6"
            gutterBottom
          >
            The Magic of Omni-Liquid Detection
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "15px", md: "20px" } }}
            variant="body1"
            paragraph
          >
            <strong>Multi-purpose:</strong> From milk and edible oils to honey,
            Lotuster can test virtually any liquid for adulterants,
            contaminants, and impurities.
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "15px", md: "20px" } }}
            variant="body1"
            paragraph
          >
            <strong>Portable Power:</strong> Small enough to fit in your pocket,
            Lotuster is designed for on-the-go testing. Take it to the farm, the
            factory, or the grocery store—quality assurance is now at your
            fingertips.
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "15px", md: "20px" } }}
            variant="body1"
            paragraph
          >
            <strong>Cost-Effective:</strong> By dramatically reducing the cost
            of quality control by 99.6%, Lotuster makes state-of-the-art testing
            accessible to everyone, not just large corporations.
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "18px", md: "25px" } }}
            variant="h6"
            gutterBottom
          >
            Benefits for Dairy Farmers
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "15px", md: "20px" } }}
            variant="body1"
            paragraph
          >
            <strong>Enhanced Trust:</strong> With Lotuster, you can provide
            verifiable proof of milk purity to your customers, building stronger
            relationships and brand loyalty.
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "15px", md: "20px" } }}
            variant="body1"
            paragraph
          >
            <strong>Reduced Costs:</strong> Traditional lab tests are expensive
            and time-consuming. Lotuster slashes these costs, making
            high-quality testing affordable for even small-scale farmers.
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "15px", md: "20px" } }}
            variant="body1"
            paragraph
          >
            <strong>Improved Efficiency:</strong> Quickly identify and rectify
            issues, reducing waste and improving overall productivity.
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "15px", md: "20px" } }}
            variant="body1"
            paragraph
          >
            We have introduced LCA (Life Cycle Assessment) to make dairy farming
            sustainable.
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "18px", md: "25px" } }}
            variant="h6"
            gutterBottom
          >
            Ready to Boost Quality Control?
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "15px", md: "20px" } }}
            variant="body1"
            paragraph
          >
            Take the next step in ensuring liquid purity with Lotuster. Secure
            your license today and bring state-of-the-art adulterant detection
            to your operation.
          </Typography>
          <Typography
            sx={{ fontSize: { xs: "15px", md: "20px" } }}
            variant="body1"
            paragraph
          >
            Connect with us to get your Lotuster license.
          </Typography>
        </Box>
      </BackGround>
    </>
  );
};

export default Technology;
